export default __webpack_public_path__ + "static/media/logo.36f2a558.svg";